<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
  >
    <template #header>
      <h3>{{ $t('lineidpage.dialog.deletemultiple.header') }}</h3>
    </template>

    <div class="confirmation-content">
      <span>{{ $t('lineidpage.dialog.deletemultiple.content') }}</span>
    </div>
    <template #footer>
      <Button
        :label="$t('lineidpage.dialog.abortButton')"
        icon="pi pi-times"
        class="p-button-rounded p-button-outlined"
        @click="close"
      />
      <Button
        :label="$t('lineidpage.dialog.confirmButton')"
        icon="pi pi-check"
        class="p-button-rounded p-button-outlined"
        @click="deleteMultipleLineId"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: 'LineIdMultipleDeleteDialog',
  components: {Dialog, Button},
  props: {
    lineIds: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'delete'],
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    close() {
      this.isVisible = false;
    },

    async deleteMultipleLineId() {
      this.dialogMultipleDelete = false
      const ids = this.lineIds.map(line => line.id)
      try {
        await this.$lineIdService.deleteMultipleLineId(ids)
        this.$emitter.emit('toast', {severity: 'success', message: 'lineidpage.toast.deletemultiple.success'})
        this.isVisible = false;
        this.$emit('delete', this.lineIds);
      } catch (e) {
        const errors = e.response.data.map(error => this.$t(error))
        this.$emitter.emit('toast', {severity: 'error', message: errors.join(', ')})
      }
    },
  }
}
</script>
